// List state wrapper (spec §4.6): loading, empty, error-with-retry. Every
// Phase 4 list screen renders through this.
import type { ReactNode } from 'react';
import Loader from '@/components/ui/Loader/Loader';

interface Props<T> {
  data: T[] | null;
  error: string | null;
  empty: ReactNode;
  onRetry: () => void;
  children: (data: T[]) => ReactNode;
  rows?: number;
}

function ListState<T>({ data, error, empty, onRetry, children, rows = 3 }: Props<T>) {
  if (error) {
    return (
      <div className="nova-p4-card" style={{ textAlign: 'center' }}>
        <p className="nova-p4-muted" style={{ marginBottom: 12 }}>{error}</p>
        <button type="button" className="nova-p4-secondary" style={{ width: 'auto', padding: '10px 24px' }} onClick={onRetry}>
          Try again
        </button>
      </div>
    );
  }
  if (!data) return <Loader rows={rows} />;
  if (data.length === 0) return <div className="nova-p4-empty">{empty}</div>;
  return <>{children(data)}</>;
}

export default ListState;
